export default "__VITE_ASSET__BQT6THYX__"